<template>
    <div id="file-upload-affiliate-component">
        <div id="mainContent">

            <form id="formImport" class="formImport">
                <div class="row justify-content-center scr-gap-15-0">
                    <div class="col-12 col-md-4">
                        <select name="role_id" v-model="affiliate.role_id" id="">
                            <option :value="0">Tipo de Afiliado</option>
                            <option :value="8">Titular</option>
                            <option :value="9">Dependiente</option>
                        </select>
                    </div>
                    <div class="col-12 col-md-4">
                        <div class="fotoUploader">
                            <span class="btn btn-file">
                                Archivo de Afiliados <br> <i class="fas fa-upload"></i> <input type="file"
                                                                                               data-label="avatar"
                                                                                               name="xlsFile"
                                                                                               v-on:change="getFile"
                                                                                               placeholder="avatar">
                            </span>
                            <span class="label-file-papeleria alert alert-info file"></span>
                        </div>
                    </div>
                    <div class="col-12 col-md-4">
                        <button id="dyn-button" type="button" class="btn btn-primary" v-on:click="guardar()">Cargar
                        </button>
                    </div>
                </div>
            </form>

        </div>
    </div>
</template>

<script>
import {myMixins} from "../mixins/myMixins";
import {importsubsidiaryfileService} from "../../Services/ImportSubsidiaryFile.service";
import {rolesService} from "../../Services/Roles.service";
import {getFormData} from "../../Utils/getDataForm";

export default {
    name: "load-subsidiary-file",
    mixins: [myMixins],
    data() {
        return {
            roles: [],
            providers: [],
            affiliate: {
                role_id: 0,
            },
        }
    },
    methods: {

        async guardar() {
            let resp = '';
            let respVal = this.valFormulariosV3('formImport');
            const formData = getFormData('formImport');
            if (respVal) {
                this.disableSubmitBtn(true);
                resp = await importsubsidiaryfileService.saveOne(formData, {isForm: true});
                this.disableSubmitBtn(false);
            }
            this.modificar = false;
        },

        async index() {
            this.roles = await rolesService.getProvidersForSinester();
        },

        getFile(event) {
            this.getNameFile(event, 'file');
        },

    },
    mounted() {
        this.index();
    }
}
</script>

<style scoped>
.fotoUploader {
    margin-top: 0
}
</style>
